import {BaseWidget} from "./BaseWidget";
import * as widgets from './Widgets'
import {dropDownFiltering, prepareAllowedValues} from './Widgets'
import {isArabic} from "../common/Translator";
import {areEqual, getFirstNotNullObj, isEmptyOrNull, isNullOrUndefined, namaCompare} from "../common/NamaCommon";
import {toCSVLineWithSep} from "../common/StringUtils";
import {ExpressionEditor} from "../views/list/CriteriaEditorWidget";
import {singleAllowedValuesForEntityTypes} from "../grid/NamaGridWidget";
import {constructDataFromAllowedValues} from "../views/list/ListViewColumns";
import {
    documentFileEntityTypes,
    isEntityEnabled,
    isSimpleEntity,
    masterFileEntityTypes,
    sortedAllEntityTypes,
    sortedSimpleAndOtherAllEntityTypes
} from "../login/ClientCache";
import * as FieldType from "../constants/FieldType";
import * as CommonConstants from "../constants/CommonConstants";

export function sortData(allowedEntityTypes) {
    if (isArabic())
        allowedEntityTypes.sort((o1, o2) => namaCompare(o1.arabicText, o2.arabicText));
    else
        allowedEntityTypes.sort((o1, o2) => namaCompare(o1.englishText, o2.englishText));
}

function createGenericRefEntityTypeMeta(fieldMetadata) {
    let allowedValues = fieldMetadata.allowedValues;
    if (isEmptyOrNull(allowedValues))
        allowedValues = sortedAllEntityTypes;
    else if (allowedValues.length == 1) {
        if (areEqual(allowedValues[0], CommonConstants.GENERIC_REF_ALL) || isEmptyOrNull(allowedValues[0]))
            allowedValues = sortedAllEntityTypes;
        else if (areEqual(allowedValues[0], CommonConstants.GENERIC_REF_SIMPLE_AND_ALL))
            allowedValues = sortedSimpleAndOtherAllEntityTypes;
        else if (areEqual(allowedValues[0], CommonConstants.GENERIC_REF_ALL_DOCS))
            allowedValues = documentFileEntityTypes;
        else if (areEqual(allowedValues[0], CommonConstants.GENERIC_REF_ALL_MASTERS))
            allowedValues = masterFileEntityTypes;
    }
    if (allowedValues && fieldMetadata.fieldType === FieldType.EntityType)
        allowedValues = allowedValues.filter(value => isEntityEnabled(value) || isSimpleEntity(value));
    fieldMetadata.allowedValues = allowedValues;
}

/**
 * @implements FieldsOwner
 */
export class GenericReferenceWidget extends BaseWidget {

    hideEntityTypeDropDown() {
        let that = this;
        let element = that.findElement();
        element.find(".genRefEntityType").remove();
        let genRefPart = element.find(".genericReference");
        genRefPart.removeClass("col-lg-8");
        genRefPart.addClass("col-lg-12");

    }

    afterAttach() {
        super.afterAttach();
        let that = this;
        let element = that.findElement();
        let dropDown = $(`
            <div class="genRefEntityType col-lg-4 col-md-12 remove-padding-x">
                <input class="w-100" id="${that.elementId}DropDown"/>
            </div>`);

        let refWidget = that._referenceWidget = new widgets.ReferenceWidget({
            fieldMetadata: that.fieldMetadata,
            owner: that.owner,
            id: that.id
        });
        that._referenceWidget.insideGrid = that.insideGrid;
        let reference = $(`
            <div class="col-lg-8 remove-padding-x genericReference">
            </div>`);
        that.findElement().addClass("row no-gutters col-md-12");
        that.findElement().append(dropDown);
        if (that.insideGrid) {
            dropDown.addClass("w-100");
            reference.addClass("w-100");
            that.findElement().append($(`<br>`));
        }
        that.findElement().append(reference.append(refWidget.render()));
        let allowedEntityTypes = [{text: "", value: "", originText: ""}];
        createGenericRefEntityTypeMeta(that.fieldMetadata);
        let allowedValues = prepareAllowedValues(that.fieldMetadata, that.domainClassName);
        if (allowedValues)
            allowedEntityTypes = constructDataFromAllowedValues(allowedValues);
        that.dropDown = dropDown.find("#" + that.elementId + "DropDown").kendoDropDownList({
            filter: "contains",
            dataValueField: "value",
            dataTextField: "text",
            dataSource: allowedEntityTypes,
            change: (e) => {
                that._referenceWidget.changeEntityType(that.dropDown.value(), true);
                let valueFromGenRefElement = that._referenceWidget.readValueFromElement();
                if (!valueFromGenRefElement && that.dropDown.value())
                    valueFromGenRefElement = {entityType: that.dropDown.value()};
                that.onDataChanged(that.fieldMetadata.fieldId, valueFromGenRefElement, this.cellOptions);
            },
            filtering: function (ev) {
                dropDownFiltering(ev, this.dataSource);
            }
        }).data("kendoDropDownList");
        refWidget.afterAttach();
        if (singleAllowedValuesForEntityTypes({allowedValues: allowedValues}))
            that.hideEntityTypeDropDown();
    }

    createElement(style) {
        return $(`<div ${style} id="${this.elementId}" nid="${this.id}">`)
    }

    setValueInElement(value) {
        let that = this;
        if (value && value.entityType) {
            that._referenceWidget.setEnabled(that.enabled);
            that.dropDown.value(value.entityType)
            that._referenceWidget.changeEntityType(value.entityType)
            that._referenceWidget.setValue(value);
        } else {
            that.dropDown.value("");
            that._referenceWidget.setValueInElement(value);
            that._referenceWidget.setEnabled(false);
        }
    }

    readValueFromElement() {
        return this._referenceWidget.readValueFromElement();
    }

    addDataWidget(widget) {

    }

    onDataChanged(fieldId, fieldValue) {
        let that = this;
        if (that.owner instanceof ExpressionEditor && isNullOrUndefined(fieldValue.id))
            return;
        that.owner.onDataChanged(that.fieldMetadata.fieldId, fieldValue, that.cellOptions);
    }

    rootElement() {
        return this.findElement();
    }

    getFieldValue(fieldId, row) {
        return this.owner.getFieldValue(fieldId, row);
    }

    get entityType() {
        return getFirstNotNullObj(this._entityType, this.owner.entityType);
    }

    set entityType(entityType) {
        this._entityType = entityType;
    }

    get metaData() {
        return this.owner.metaData;
    }

    getPlaceExtraFieldFilterId() {
        return this.owner.getPlaceExtraFieldFilterId();
    }

    setFieldValue(fieldId, value, row) {
        this.owner.setFieldValue(fieldId, value, row);
    }

    setEnabled(enabled) {
        let that = this;

        that._referenceWidget.setEnabled(enabled);
        if (enabled === "Enabled" || enabled === true) {
            if (that.dropDown) {
                that.dropDown.readonly(false);
                that.dropDown.wrapper.addClass("enabledDropDown");
                that.dropDown.enable(true);
            }
            that.findElement().removeClass('nama-disabled');
            that.enabled = true;
        } else {
            if (that.dropDown) {
                that.dropDown.enable(false);
                that.dropDown.readonly(true);
                that.dropDown.wrapper.removeClass("enabledDropDown");
            }
            that.findElement().addClass('nama-disabled');
            that.enabled = false;
        }
    }

    valueOrParsedValue(value) {
        return value;
    }

    referenceTable() {
        return toCSVLineWithSep(",", this.fieldMetadata.allowedValues);
    }
}